import React, { useEffect, useState } from "react";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

const InputController = (props) => {
  const {
    control,
    errors,
    name,
    label,
    isSmall = false,
    size = "medium",
    isDisabled = false,
    setField,
    inputValue,
    mainLogin = false,
    comment,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      sx={{
        "& .MuiInputBase-input.Mui-disabled": {
          WebkitTextFillColor: (theme) => theme.palette.black.main,
        },
        "& .MuiInputLabel-root.Mui-disabled": {
          color: "red",
        },
      }}
      render={({ field }) => (
        <TextField
          multiline={comment ? true : false}
          rows={comment ? 2 : undefined}
          {...field}
          value={field.value}
          disabled={isDisabled}
          label={label}
          variant="outlined"
          size={size}
          fullWidth={!isSmall}
          onChange={(e) => {
            field.onChange(e.target.value);
            setField && setField(e.target.value);
          }}
          placeholder={label}
          sx={{
            "& .MuiInputBase-root": {
              height: !mainLogin && !comment ? "35px !important" : undefined,
            },
            "& .MuiInputBase-root input": {
              width: !mainLogin ? "fit-content !important" : undefined,
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            },
          }}
          error={errors[name] ? true : false}
          helperText={errors[name] ? errors[name].message : ""}
        />
      )}
    />
  );
};

export default InputController;

const InputControllerWithIcon = (props) => {
  const {
    control,
    errors,
    name,
    label,
    icon,
    isSmall = false,
    size = "medium",
    isDisabled = false,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          disabled={isDisabled}
          {...field}
          label={label}
          variant="outlined"
          size={size}
          fullWidth={!isSmall}
          placeholder={label}
          sx={{
            "& .MuiInputBase-root": {
              height: "35px !important",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{ color: (theme) => theme.palette.black.main }}
              >
                {icon}
              </InputAdornment>
            ),
          }}
          error={errors[name] ? true : false}
          helperText={errors[name] ? errors[name].message : ""}
        />
      )}
    />
  );
};

const SimpleTextField = (props) => {
  const [fieldValue, setFieldValue] = useState("");
  const [dataAddded, setDataAdded] = useState(false);

  const {
    name,
    label,
    isSmall = false,
    size = "medium",
    isDisabled = false,
    setField,
    getValues,
    handleDeleteArr,
    currentField,
  } = props;
  return (
    <>
      <Box sx={{ display: "flex", gap: "2px" }}>
        <TextField
          id={name}
          label={label}
          value={fieldValue || getValues(name) || ""}
          size={size}
          fullWidth={!isSmall}
          disabled={!isDisabled}
          onChange={(e) => {
            setFieldValue && setFieldValue(e.target.value);
          }}
          sx={{
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.palette.black.main,
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.palette.black.main,
            },
          }}
        />
        <IconButton
          onClick={() => {
            setField(name, fieldValue);
            setDataAdded(true);
          }}
          disabled={dataAddded}
        >
          <AddIcon
            sx={{ width: "16px", color: dataAddded ? "grey" : "green" }}
          />
        </IconButton>
        <IconButton
          onClick={() => {
            setField(name, "");
            handleDeleteArr(currentField);
          }}
        >
          <CloseIcon sx={{ width: "16px", color: "red" }} />
        </IconButton>
      </Box>
    </>
  );
};

export { InputControllerWithIcon, SimpleTextField };
